module.exports = __webpack_public_path__ + "static/media/icon-close.1edaa373.svg";